var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "span",
    {
      staticClass: "Polaris-Badge",
      class: {
        "Polaris-Badge--toneSuccess": _vm.type === "success",
        "Polaris-Badge--toneAttention": _vm.type === "attention",
        "Polaris-Badge--toneInfo": _vm.type === "info"
      }
    },
    [
      _c("span", { staticClass: "Polaris-Text--root Polaris-Text--bodySm" }, [
        _vm._v(_vm._s(_vm.title))
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }